import { Outlet, NavLink, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { FWLogo } from "@/components/BrandMarks";

const NAV = [
    { to: "/framework", label: "Home", end: true },
    { to: "/framework/services", label: "Services" },
    { to: "/framework/coaches", label: "Coaches" },
    { to: "/framework/swing-analysis", label: "Swing AI" },
    { to: "/framework/stringing", label: "The Lab" },
    { to: "/framework/events", label: "Events" },
    { to: "/framework/store", label: "Store" },
    { to: "/framework/contact", label: "Contact" },
];

export default function FrameworkLayout() {
    const [open, setOpen] = useState(false);
    const location = useLocation();
    useEffect(() => { setOpen(false); window.scrollTo(0, 0); }, [location.pathname]);

    return (
        <div className="fw-body min-h-screen" data-testid="framework-layout">
            <header
                className="fixed top-0 inset-x-0 z-50 bg-black/80 backdrop-blur-xl border-b border-white/10"
                data-testid="framework-header"
            >
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
                    <Link to="/framework" className="flex items-center gap-3" data-testid="framework-logo-home">
                        <FWLogo size={28} />
                        <div className="flex flex-col leading-none">
                            <span className="fw-heading text-sm leading-none text-white">FRAMEWORK</span>
                            <span className="fw-label-lime text-[9px] mt-1">Tennis</span>
                        </div>
                    </Link>

                    <nav className="hidden lg:flex items-center gap-1">
                        {NAV.map((n) => (
                            <NavLink key={n.to} to={n.to} end={n.end}
                                data-testid={`framework-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                className={({ isActive }) =>
                                    `fw-mono uppercase text-[11px] tracking-[0.22em] px-3 py-2 transition-colors ${
                                        isActive ? "text-white" : "text-white/60 hover:text-white"
                                    }`
                                }>
                                {n.label}
                            </NavLink>
                        ))}
                    </nav>

                    <Link to="/framework" className="hidden lg:flex items-center gap-1.5 fw-mono uppercase text-[10px] tracking-[0.25em] text-white/50 hover:text-white" data-testid="framework-switch-brand">
                        Metro ATL · GA
                    </Link>

                    <button onClick={() => setOpen(!open)} className="lg:hidden p-2 text-white" data-testid="framework-mobile-menu-btn" aria-label="Toggle menu">
                        {open ? <X size={22} /> : <Menu size={22} />}
                    </button>
                </div>
                {open && (
                    <div className="lg:hidden border-t border-white/10 bg-black">
                        <nav className="flex flex-col p-4">
                            {NAV.map((n) => (
                                <NavLink key={n.to} to={n.to} end={n.end}
                                    data-testid={`framework-mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                                    className={({ isActive }) => `py-3 fw-mono uppercase text-xs tracking-[0.2em] border-b border-white/5 ${isActive ? "text-white" : "text-white/70"}`}>
                                    {n.label}
                                </NavLink>
                            ))}
                            <Link to="/framework" className="py-3 fw-mono uppercase text-xs tracking-[0.2em] text-white/50" data-testid="framework-mobile-switch-brand">Metro Atlanta, GA</Link>
                        </nav>
                    </div>
                )}
            </header>

            <main className="pt-16">
                <Outlet />
            </main>

            <footer className="border-t border-white/10 bg-[#030303] mt-24" data-testid="framework-footer">
                <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid md:grid-cols-4 gap-10">
                    <div className="md:col-span-2">
                        <div className="flex items-center gap-3">
                            <FWLogo size={30} />
                            <span className="fw-heading text-white">FRAMEWORK TENNIS</span>
                        </div>
                        <p className="mt-4 text-white/50 max-w-md leading-relaxed">
                            Step into an alternate reality built for training.
                            Mind. Body. Performance. Technique. Racquet Tech. Recovery.
                        </p>
                    </div>
                    <div>
                        <div className="fw-label mb-3">Explore</div>
                        <ul className="space-y-2 text-sm text-white/70">
                            {NAV.slice(1, 5).map((n) => (
                                <li key={n.to}><Link to={n.to} className="hover:text-white">{n.label}</Link></li>
                            ))}
                        </ul>
                    </div>
                    <div>
                        <div className="fw-label mb-3">Contact</div>
                        <ul className="space-y-2 text-sm text-white/70">
                            <li>desk@frameworktennis.com</li>
                            <li>Metro Atlanta, GA</li>
                            <li className="text-white/40">Private facilities by client invite</li>
                        </ul>
                    </div>
                </div>
                <div className="border-t border-white/5">
                    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between fw-mono uppercase tracking-[0.25em] text-[10px] text-white/30">
                        <span>© 2026 Framework Tennis</span>
                        <span>Portal Sys.v1</span>
                    </div>
                </div>
            </footer>
        </div>
    );
}
